import { createSlice } from '@reduxjs/toolkit';

export const browserAutoFill = createSlice({
  name: 'BROWSER_AUTOFILL',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setBrowserAutoFillerVisible(state, action) {
      const { payload } = action;
      const { isVisible } = payload;

      state.isVisible = isVisible;
    },
  },
});

const { actions, reducer } = browserAutoFill;

export const { setBrowserAutoFillerVisible } = actions;

export default reducer;
